import { FECH_VIEW_SAVE_URL } from '../../../../constants/ApplicationUrl';
import api from "../../../../dependencies/utils/Api"


export const ViewSave = {

    saveView80iac(params) {

        return api.POST(FECH_VIEW_SAVE_URL, params).
            then((response) => {
                const { data = {} } = response;
                return data;
            });
    },
}

